import StyledHeading from '/shared/styled/components/StyledHeading';
import StyledParagraph from '/shared/styled/components/StyledParagraph';

export const defaultBottomAll = (
  <div className="default-all">
    <StyledHeading as="h2" $type="h1" $hasExtraBottomMargin $hasSuperTopMargin>
      Inputting data for this category
    </StyledHeading>
    <StyledParagraph $largeText>
      You can enter activity data, supplier data, or a combination of these, depending on the data available for this
      emissions category.
    </StyledParagraph>
    <StyledHeading as="h2" $type="h1" $hasExtraBottomMargin $hasSuperTopMargin>
      Activity data
    </StyledHeading>
    <StyledParagraph $largeText>
      Activity-based emissions are calculated using activity data — that is, the quantity of products or services your
      organisation used (such as fuel, transport, or electricity) — multiplied by industry-standard emission factors
      (which may be local, national, or market-based).
    </StyledParagraph>
    <StyledParagraph $largeText>
      This method is applicable when consistent, well-tracked operational data is available but no supplier emissions
      data, enabling accurate estimation from known activities.
    </StyledParagraph>
    <StyledParagraph $largeText $bold>
      Use this if:
    </StyledParagraph>
    <StyledParagraph $largeText>
      You have usage data but not emissions info from suppliers or third parties.
    </StyledParagraph>

    <StyledHeading as="h2" $type="h1" $hasExtraBottomMargin $hasSuperTopMargin>
      Supplier data
    </StyledHeading>
    <StyledParagraph $largeText>
      This method uses emissions data obtained directly from your suppliers, aligning with the GHG Protocol’s preference
      for supplier-specific information.
    </StyledParagraph>
    <StyledParagraph $largeText $bold>
      Supplier data can include:
    </StyledParagraph>
    <ul>
      <li>
        <StyledParagraph $largeText>
          Carbon intensity data (e.g., kg CO₂e per unit of product or service)
        </StyledParagraph>
      </li>
      <li>
        <StyledParagraph $largeText>
          Total absolute emissions (e.g., total kg CO₂e for the quantity of product purchased during the reporting
          period)
        </StyledParagraph>
      </li>
    </ul>
    <StyledParagraph $largeText>
      This flexibility allows you to calculate emissions based on the level of detail your suppliers provide. If using
      intensity, you’ll also need usage data (e.g. quantity or distance); if using absolute emissions, no calculation is
      needed.
    </StyledParagraph>
    <StyledParagraph $largeText $bold>
      Use this if:
    </StyledParagraph>
    <StyledParagraph $largeText>
      Your suppliers provide emissions data, either as intensity or total emissions.
    </StyledParagraph>
  </div>
);
